module.exports = __webpack_public_path__ + "img/mobile-left-arrow-unselected.64101c37.svg";